import React from "react";
import ContactUs from "../../../components/ContactUs.js";
import { Helmet } from "react-helmet-async";

const ClickToCall = () => {
  const scrollToContact = () => {
    document
      .getElementById("contact-section")
      .scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <Helmet>
        Click-to-call
        <meta
          name="description"
          content="Increase customer engagement and sales with Ayanshtech’s Click to Call Solution. Connect instantly, boost conversions, and enhance customer experience effortlessly."
        />
        <meta name="copyright" content="codeglim" />
        <meta
          property="og:title"
          content="Click to Call Solution | Boost Customer Engagement & Sales | Ayanshtech Solutions"
        />
        <meta property="og:site_name" content="Ayanshtech Solutions" />
        <meta
          property="og:url"
          content="https://ayanshtechnology.com/click-to-call"
        />
        <meta
          property="og:description"
          content="Increase customer engagement and sales with Ayanshtech’s Click to Call Solution. Connect instantly, boost conversions, and enhance customer experience effortlessly."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://ayanshtechnology.com/assets/logo.png"
        />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@Ayanshtech Solutions" />
        <meta
          name="twitter:title"
          content="Click to Call Solution | Boost Customer Engagement & Sales | Ayanshtech Solutions"
        />
        <meta
          name="twitter:description"
          content="Increase customer engagement and sales with Ayanshtech’s Click to Call Solution. Connect instantly, boost conversions, and enhance customer experience effortlessly."
        />
        <meta
          name="twitter:image"
          content="https://ayanshtechnology.com/assets/logo.png"
        />
        <link
          rel="canonical"
          href="https://ayanshtechnology.com/click-to-call"
        />
        <title>
          Click to Call Solution | Boost Customer Engagement & Sales |
          Ayanshtech Solutions
        </title>
      </Helmet>
      <div className=" flex flex-col items-center justify-center p-6">
        <div className=" py-5 w-full">
          <div className="flex flex-col lg:flex-row items-center p-4 lg:space-x-16">
            <div className="lg:w-3/4 lg:text-left">
              <h1 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-4">
                Click to Call Solution for Business Growth
              </h1>

              <p className="sm:text-base md:text-lg lg:text-lg mb-3">
                We specialize in building custom Click to Call web applications
                that help businesses connect with customers instantly and boost
                conversions. Our Click to Call solutions are designed to deliver
                an engaging, seamless, and interactive experience—enhancing
                communication and driving measurable growth.
              </p>

              <p className="sm:text-base md:text-lg lg:text-lg leading-relaxed mb-3">
                With our end-to-end web app development expertise, we ensure
                every project aligns perfectly with your business goals. As a
                leading Click to Call solution provider, we deeply understand
                your requirements to deliver flawless implementation, faster
                response times, and improved customer engagement.
              </p>
              <p className="sm:text-base md:text-lg lg:text-lg leading-relaxed mb-3">
                Empower your business with smart Click to Call solutions that
                make communication effortless and accelerate your growth
                journey.
              </p>

              <button
                onClick={scrollToContact}
                className="bg-green-600 text-white hover:bg-yellow-500 hover:text-green-700 hover:border hover:border-yellow-500
 font-semibold py-2 px-4 rounded-full mt-6"
              >
                Get Started
              </button>
            </div>

            <div className="flex justify-center mb-12 lg:mb-0 mt-5">
              <img
                src="/assets/images/headerSection/clicktocall1.png"
                alt="Click to Call Solution"
                className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
              />
            </div>
          </div>
        </div>

        <div className="text-center mb-5 mt-10">
          <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
            Key Features of Click-to-Call Solutions
          </h2>
          <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
            Our Click-to-Call services are designed to provide instant
            communication, ensuring an unmatched customer experience and
            boosting business efficiency.
          </p>
        </div>

        <div className=" p-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon10.png"
                alt="Real-Time Communication"
                className="w-10 h-10"
              />
              <p className="text-lg">Real-Time Communication</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon9.png"
                alt="Call Analytics"
                className="w-10 h-10"
              />
              <p className="text-lg">Call Analytics</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon8.png"
                alt="CRM Integration"
                className="w-10 h-10"
              />
              <p className="text-lg">CRM Integration</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon7.png"
                alt="Customizable Workflows"
                className="w-10 h-10"
              />
              <p className="text-lg">Customizable Workflows</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon6.png"
                alt="Secure Connections"
                className="w-10 h-10"
              />
              <p className="text-lg">Secure Connections</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon5.png"
                alt="IVR Integration"
                className="w-10 h-10"
              />
              <p className="text-lg">IVR Integration</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon5.png"
                alt="Geo-Tracking"
                className="w-10 h-10"
              />
              <p className="text-lg">Geo-Tracking</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon3.png"
                alt="24/7 Availability"
                className="w-10 h-10"
              />
              <p className="text-lg">24/7 Availability</p>
            </div>
          </div>
        </div>

        <div className="text-center mb-5 mt-20">
          <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
            Why Choose Our Click-to-Call Solutions?
          </h2>
          <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
            Our expertise ensures that your Click-to-Call systems are not just
            functional but deliver measurable business results. From seamless
            integration to real-time analytics, we deliver excellence in every
            aspect.
          </p>
        </div>

        <div className=" p-4">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="w-full md:w-1/3 p-4">
              <img
                src="/assets/images/headerSection/clicktocall2.png"
                alt="Click to Call Benefits"
                className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
              />
            </div>

            <div className="md:w-1/2 lg:w-3/4 p-4 grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon11.png"
                  alt="Enhanced Efficiency"
                  className="w-10 h-10"
                />
                <p className="text-lg">
                  Boost operational efficiency with real-time customer
                  interactions.
                </p>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon12.png"
                  alt="Easy Integration"
                  className="w-10 h-10"
                />
                <p className="text-lg">
                  Integrate seamlessly with your website or application.
                </p>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon13.png"
                  alt="Actionable Insights"
                  className="w-10 h-10"
                />
                <p className="text-lg">
                  Leverage actionable insights with detailed call analytics.
                </p>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon14.png"
                  alt="Cost-Effective"
                  className="w-10 h-10"
                />
                <p className="text-lg">
                  Reduce operational costs with affordable communication
                  solutions.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div id="contact-section">
          <ContactUs />
        </div>
      </div>
    </>
  );
};

export default ClickToCall;
